import React from 'react'
import { SlIcon } from '@shoelace-style/shoelace/dist/react'
import StyledNetworkItem from '../styles'

const Facebook: React.FC = () => (
  <StyledNetworkItem
    href="https://facebook.com/nomiswap"
    target="_blank"
    rel="noreferrer noopener"
    className="text-brand-facebook"
  >
    <SlIcon library="social" name="facebook" />
  </StyledNetworkItem>
)

export default Facebook
